import { useCallback, useMemo } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import styles from './CustomDomainModal.module.css'
import { Modal } from 'react-bootstrap'
import { Formik } from 'formik'
import StepRenderer from './components/StepRenderer'
import { ProgressIndicator } from './components/SharedComponents'
import CustomModal from 'components/CustomModal/CustomModal'
import { CustomDomainProvider } from './context/CustomDomainProvider'
import { addWasmerDomainRecord } from '../../services/custom-domain'
import { showMessageModal, fetchUserData } from '../../Manage/actions'
import { useCustomDomainModal } from './hooks/useCustomDomainModal'
import { getCustomDomainSchema } from './hooks/domainValidation'

export const domainErrorMessage = {
  show: true,
  error: true,
  title: 'Unable to set up domain',
  message: 'Please contact support.'
}

export const formatWasmerRecords = (wasmerData) => {
  const records = [
    ...(wasmerData?.record?.expectedDnsRecords || []),
    ...(wasmerData?.cnameRecord?.expectedDnsRecords || []),
    ...(wasmerData?.anameRecord || []),
    ...(Array.isArray(wasmerData?.cnameRecord) ? wasmerData.cnameRecord : [])
  ]
  return records.map((record) => ({
    type: record.recordType || record.type,
    host: record.host,
    value: record.value
  }))
}

const PhpCustomDomainModal = (props) => {
  const { show, onClose, domains = [], modalData } = props

  const { activeStep, initialValues, handleNext, handleBack, handleClose, setActiveStep } = useCustomDomainModal({
    show,
    onClose,
    modalData
  })

  const dispatch = useDispatch()
  const { userProfile } = useSelector((state) => state.manage)

  const publishToCustomDomain = localStorage.getItem('publishToCustomDomain')

  const isPublishFlow = useMemo(() => {
    return !!publishToCustomDomain && !modalData?.isPhpDomain
  }, [publishToCustomDomain, modalData])

  const handleCheckEntri = useCallback(
    async (payload, formik) => {
      try {
        const appName = payload.publishToCustomDomain || localStorage.getItem('publishToCustomDomain')
        if (!appName) {
          dispatch(showMessageModal(domainErrorMessage))
          return
        }

        const { data } = await addWasmerDomainRecord({
          domain: payload.domain,
          appName: appName
        })

        const records = formatWasmerRecords(data)

        if (records.length > 0) {
          const transformedData = {
            domain: payload.domain,
            isPhpDomain: true,
            phpDomainData: data,
            records: records
          }
          formik.setFieldValue(`dnsRecords.data`, transformedData)
          dispatch(fetchUserData(false))
          return 'manual'
        }
      } catch {
        dispatch(showMessageModal(domainErrorMessage))
      }
    },
    [dispatch]
  )

  const validationSchema = getCustomDomainSchema(domains)

  return (
    <CustomDomainProvider>
      <CustomModal
        aria-labelledby="contained-modal-title-vcenter"
        show={show}
        centered
        onHide={handleClose}
        backdrop="static"
        enforceFocus={false}
      >
        <Modal.Header className={styles.header} closeButton>
          {isPublishFlow && (
            <div className={styles.progress}>
              <ProgressIndicator steps={5} activeIndex={activeStep} />
            </div>
          )}
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <Formik
            validateOnMount
            validateOnChange
            enableReinitialize
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              setSubmitting(true)
              setSubmitting(false)
            }}
          >
            {(formik) => (
              <StepRenderer
                activeStep={activeStep}
                formik={formik}
                handlers={{
                  handleNext,
                  handleBack,
                  handleClose,
                  setActiveStep,
                  handleCheckEntri
                }}
                props={{
                  ...props,
                  userProfile,
                  variant: 'php'
                }}
              />
            )}
          </Formik>
        </Modal.Body>
      </CustomModal>
    </CustomDomainProvider>
  )
}

export default PhpCustomDomainModal
